// Static Client
export const CLIENT_STATE = 'washington';
export const CLIENT_CITY = 'bellevue';

// Server IP
export const S3_BUCKET_PREFIX = 'https://ai4curb.s3.us-west-2.amazonaws.com';
export const S3_BUCKET_CLIENT_URL = `${S3_BUCKET_PREFIX}/${CLIENT_STATE}/${CLIENT_CITY}`;

//URL: 34.218.214.168:8000/get_nearby_parking_sign_zone?latitude=45.52613&longitude=-73.595025&searchRange=300&database=MontrealStreet&arrivalDatetime=2022-12-20 17:40:00&vehicleType=0&state=QC&city=Montreal
export const SERVER_IP_ADDRESS = 'api.aioparking.com';
export const PORT_NUMBER = 8000;
export const API_LOCATION = '/ArtDistrict'
export const REQUEST_URL_PREFIX = 'https://' + SERVER_IP_ADDRESS;

export const LOCAL_API_REQUEST = REQUEST_URL_PREFIX + API_LOCATION;
export const AWS_API_REQUEST = 'https://ys1maux784.execute-api.us-west-2.amazonaws.com/beta';

//https://ys1maux784.execute-api.us-west-2.amazonaws.com/beta/get_nearby_parking_sign_zone?latitude=47.6155&longitude=-122.2033&database=BellevueZone&arrivalDatetime=2022-12-20 17:40:00&vehicleType=0&searchRange=10&city=Bellevue&state=WA

// Bellevue: https://api.aioparking.com/ArtDistrict/get_nearby_parking_sign_zone?latitude=47.6156024&longitude=-122.203819&searchRange=3&database=BellevueStreet&arrivalDatetime=2024-04-22T14:04:41&state=WA&desireTime=0
//       let apiUrl = `https://api.aioparking.com/ArtDistrict/get_nearby_parking_sign_zone?latitude=${latitude}&longitude=${longitude}&searchRange=${searchRange}&database=${database}&arrivalDatetime=${arrivalDateTime}&vehicleType=${vehicleType}&state=${state}&allSign=${allSign}`;

// List of APIs used in the app
export const ENDPOINTS = {
  GET_NEARBY_PARKING_SIGN_ZONE: '/get_nearby_parking_sign_zone',
  GET_SIGNS_NAVIGATION: '/get_signs_navigation'
};

export const COMPLETE_STREET_OBJECTS_ENDPOINT = "https://7ahp1pd0ve.execute-api.us-west-2.amazonaws.com/objects";

// STATIC API:
export const BELLEVUE_ADDITIONAL_DATA = 'https://yw2lfuz2d5.execute-api.us-west-2.amazonaws.com/beta/get_nearby_zone_objects?latitude=47.6155&longitude=-122.2033&database=BellevueZone&searchRange=3'

export const TIME_OUT_IN_SECOND = {
  GPS_ERROR: 30,
  WAIT_FOR_SERVER_RESPONSE: 60
};

export const BACKDOOR_FIREBASE_TOKEN = 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjFkYmUwNmI1ZDdjMmE3YzA0NDU2MzA2MWZmMGZlYTM3NzQwYjg2YmMiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vYWk0Y3VyYiIsImF1ZCI6ImFpNGN1cmIiLCJhdXRoX3RpbWUiOjE3MjI3MTQzNTEsInVzZXJfaWQiOiIxbVFYV2hXM0xBUHRMNzJLSjlSVmcyQ1pMdEcyIiwic3ViIjoiMW1RWFdoVzNMQVB0TDcyS0o5UlZnMkNaTHRHMiIsImlhdCI6MTcyMjcxNDM1MSwiZXhwIjoxNzIyNzE3OTUxLCJlbWFpbCI6InB1dHRoaWRhc2Ftcml0aEBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsicHV0dGhpZGFzYW1yaXRoQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.j9WK0TwGJID89g7CoDMN1xp7w1AVvTZptvcB8KBL2klP28yNHvjXwHS6fUG04b4_LHrGrrRGoWiVGrf-e1iZvPMAIrnsfzBhV2RjkG_T5Rw06aluFDLvxtaxz4QE6dHFqsXzJRs7OXAz8iR-vcL5DTRIGZos8aaTyujmqklSf-Jdww3OpVCt8u8_5wzmRwe1qOmPX2NY3WXE-Od6n6k0hSZWcii7qLa6mdRbWXMHlRG7zQNMt9dFjZwZdEr8ElFPLZ1VAFaehQc_JgWDr7-7azhitW1sUh1uVm-gDhbSPSAhzZsa6f1dAiSGSinGMlkdAEgQdEuAt8nTDGID4NvYsw';